<template>
  <v-main>
    <MainMenu />
    <div class="responsive-public-template-content">
      <div class="row">
        <div class="col-12 text-center">
          <h3>Confirmation de votre compte</h3>
        </div>
        <div class="col-12 offset-md-3 col-md-6">
          <v-alert v-if="displayForm" outlined type="error" prominent border="left" text>
            Aucun compte utilisateur n'est associé à ce lien
          </v-alert>
        </div>
      </div>
    </div>
    <Footer />
  </v-main>
</template>

<script>
import MainMenu from "@/components/common/MainMenu";
import Footer from "@/components/common/Footer";
import ResetPasswordForm from "@/components/ResetPassword/ResetPasswordForm";
import HttpClient from "@/services/HttpClient/HttpClient";

export default {
  name: "ConfirmEmailPage",
  data() {
    return {
      displayForm: false,
    };
  },
  components: { Footer, MainMenu },
  mounted() {
    if (this.$route.params.token !== undefined) {
      const httpClient = new HttpClient();
      httpClient
        .checkAndConfirmUser(this.$route.params.token)
        .then(() => {
          window.location.href = "/my-account?confirmation=true";
        })
        .catch((error) => {
          this.displayForm = true;
          console.error(error);
          alert(error);
        });
    }
  },
};
</script>

<style scoped></style>
